// extracted by mini-css-extract-plugin
export default {"wrapper":"BoostsPage_wrapper__1Lgl1"};